import { RPCErrorCodes } from '@discord/embedded-app-sdk';
import { showSimpleDialog } from '../../../../../shared/scripts/ui_popup/showSimpleDialog.ts';
import { DiscordMountContentFrameDispatcher } from './DiscordMountContentFrameDispatcher.ts';
export class DiscordMountSDKCommandDispatcher {
    async handleCommand(command, data) {
        try {
            // @ts-expect-error multiple...
            return await this.discordSDK.commands[command].apply(null, data);
        } catch (err) {
            if (err.code == RPCErrorCodes.INVALID_COMMAND) {
                // Expected error. Command not supported on Discord Client
                DiscordMountSDKCommandDispatcher.handleInvalidCommandError();
                return undefined;
            }
            const userCanceledPurchaseCode = 5008;
            if (err.code == userCanceledPurchaseCode) return undefined;
            const userAlreadyHasMembershipCode = 5009;
            if (err.code == userAlreadyHasMembershipCode) {
                DiscordMountContentFrameDispatcher.notifyUserAlreadyHasMembershipError(err);
                return undefined;
            }
            DiscordMountSDKCommandDispatcher.handleUnexpectedError(err);
            return undefined;
        }
    }
    static handleInvalidCommandError() {
        const invalidCommandTitle = {
            key: 'strings:popups.errors.discordUpdateClient.title'
        };
        const invalidCommandBody = {
            key: 'strings:popups.errors.discordUpdateClient.body'
        };
        showSimpleDialog({
            title: invalidCommandTitle,
            body: invalidCommandBody
        });
    }
    static handleUnexpectedError(err) {
        const unexpectedErrorTitle = {
            key: 'strings:popups.errors.discordCommandUnexpectedError.title'
        };
        const unexpectedErrorBody = {
            key: 'strings:popups.errors.discordCommandUnexpectedError.body',
            options: {
                error: err.message
            }
        };
        showSimpleDialog({
            title: unexpectedErrorTitle,
            body: unexpectedErrorBody
        });
    }
    constructor(discordSDK){
        this.discordSDK = discordSDK;
    }
}
